import { cn } from '@/components/ui/cn';
import { Text, type TextProps } from '@/components/ui/Text';

/** Bakes `font-display`; size/color are passed per call. */
export const Display = (p: TextProps) => (
  <Text variant="none" {...p} className={cn('font-display', p.className)} />
);
